import React, { useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";

import CmsEditBanner from "../helpers/cms/CmsEditBanner";
import { useCmsHook } from "../helpers/cms/cmsHook";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";

import SetupGuideHeader from "../components/SetupGuideHeader";

function SetupGuide() {
  const { setCmsInstance, cmsInstance } = useCmsHook();

  // const navLinks = [
  //   {
  //     title: "Installing of Fortnox app",
  //     navigationId: "#installingTheApp",
  //   },
  //   {
  //     title: "Sync settings",
  //     navigationId: "#syncSettings",
  //   },
  //   {
  //     title: "Select your plan",
  //     navigationId: "#subscriptionPlan",
  //   },
  //   {
  //     title: "Sync contacts and invoices",
  //     navigationId: "#syncContactsAndInvoices",
  //   },
  // ];

  useEffect(() => {
    const fetchCmsInstance = async () => {
      const cmsObj = await cmsConstructor();
      setCmsInstance(cmsObj);
    };
    fetchCmsInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="setup-guide-page">
      <SetupGuideHeader />
      {!cmsInstance ? (
        <div
          className="d-flex flex-row justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex flex-row justify-content-center align-items-center">
              <Spinner animation="border" variant="success" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex flex-row justify-content-center">
            <CmsEditBanner />
          </div>
          <Container className="p-5">
            <div className="setup-guide-main-content">
              <div className="col-md-8 col-12">
                <div className="setup-guide-content-container">
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      "cmsContent.setupGuide",
                      "setup-guide"
                    )}
                  <div>
                    <p className="setup-guide-footer-text">
                      Updated 20/ 06/ 2023
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-2 setup-guide-nav-contents">
                <div className="setup-guide-contents">
                  <h3 className="setup-guide-nav-header mt-2">CONTENTS</h3>
                  <hr className="setup-guide-horizontal-line" />
                  <ul className="setup-guide-ul">
                    {navLinks.map((el, index) => (
                      <li key={index} className="py-1">
                        <a
                          className="setup-guide-navlinks"
                          href={el.navigationId}
                        >
                          {el.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div> */}
            </div>
          </Container>
        </>
      )}
    </div>
  );
}

export default SetupGuide;
